var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('VsNoChartData',{attrs:{"height":"232px","withButton":""},scopedSlots:_vm._u([{key:"errorMessage",fn:function(){return [_c('p',[_vm._v(_vm._s(_vm._f("t")("charts.errorMessage.productFilterError")))])]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }